'use client';

import { forwardRef } from 'react';
import type {
  ListItemProps as MantineListItemProps,
  ListProps as MantineListProps,
} from '@mantine/core';
import { List as MantineList } from '@mantine/core';

import type { LockedProps } from '../types';

type ListProps = Omit<MantineListProps, LockedProps>;

type ListItemProps = Omit<MantineListItemProps, LockedProps>;

const ListComponent = forwardRef<HTMLOListElement, ListProps>((props, ref) => {
  return <MantineList {...props} ref={ref} />;
});

ListComponent.displayName = 'List';

// Re-exporting `MantineList.Item` handed callers the raw Mantine surface, so the lock on `List`
// stopped at the root. List drives its items through context, not child identity, so a
// pass-through wrapper is transparent.
const ListItem = forwardRef<HTMLLIElement, ListItemProps>((props, ref) => {
  return <MantineList.Item {...props} ref={ref} />;
});

ListItem.displayName = 'List.Item';

export const List = Object.assign(ListComponent, {
  Item: ListItem,
});
